import { useIntl } from 'react-intl'
import { WarningCircle } from 'phosphor-react'

import { DialogModal } from '../../../../components/DialogModal'
import { Button } from '../../../../components/Button'
import { type PersonType } from '../../../../enumns/personType'

type PersonTypeChangeAlertProps = {
  isChangingPersonType: boolean
  newPersonType: `${PersonType}` | null
  isOpen: boolean
  onClose: () => void
  onChangePersonType: () => Promise<void> | void
}

export const PersonTypeChangeAlert = ({
  isChangingPersonType,
  newPersonType,
  isOpen,
  onClose,
  onChangePersonType,
}: PersonTypeChangeAlertProps) => {
  const { formatMessage } = useIntl()

  return (
    <DialogModal isOpen={isOpen} onClose={onClose}>
      <div className="px-[32px] py-[24px] flex flex-col items-center">
        <WarningCircle size={72} className="mx-auto text-primary-light" />

        <p className="text-center my-[52px]">
          {formatMessage({
            id: 'DO_YOU_WANT_TO_CHANGE_THE_PAYMENT_FOR',
          })}{' '}
          {newPersonType === 'natural_person' &&
            formatMessage({ id: 'NATURAL_PERSON' })}
          {newPersonType === 'legal_person' &&
            formatMessage({ id: 'LEGAL_PERSON' })}
          {newPersonType === 'international_person' &&
            formatMessage({ id: 'INTERNATIONAL' })}
          ?
        </p>

        <div className="flex w-full gap-2">
          <Button fullWidth variant="outline" onClick={onClose}>
            {formatMessage({ id: 'CANCEL' })}
          </Button>

          <Button isLoading={isChangingPersonType} fullWidth onClick={onChangePersonType}>
            {formatMessage({ id: 'ALTER' })}
          </Button>
        </div>
      </div>
    </DialogModal>
  )
}
